import React from "react"
import {css} from "@emotion/react";
import { useStaticQuery, graphql } from "gatsby"
import AnimateHeight from 'react-animate-height';
import ListMovil from "../List/ListMovil";

const MenuMovil = ({heightList}) => {

  const data = useStaticQuery(graphql`
    {
      wordpress {
        menuItems(where: {location: MENU_MOVIL, parentId: ""}, first: 100) {
          nodes {
            id
            label
            url
            title
            target
            parentId
            childItems(before: "") {
              edges {
                node {
                  id
                  label
                  url
                  title
                  target
                  parentId
                  color {
                    color
                  }
                }
              }
            }
          }
        }
        generalSettings {
          url
        }
      }
    }
  `);

  const menuItems = data.wordpress.menuItems.nodes
  const wordPressUrl = data.wordpress.generalSettings.url

  const menuListCss = css`
    border-bottom: calc(100vw * (calc(1 / var(--width_base)))) solid #b3b3b3;
    & .menu__link{
      padding: calc(100vw * (calc(14.4 / var(--width_base)))) calc(100vw * (calc(16 / var(--width_base))));
      border-top: calc(100vw * (calc(1 / var(--width_base)))) solid #b3b3b3;
      text-transform: uppercase;
      display: flex;
      justify-content: space-between;
    }

    & .menu__link.is-active, & .menu__link.is-active .fas{
      background-color: #C7272E;
      color: white;
    }

    & .sub-menu .menu__link{
      padding: calc(100vw * (calc(14.4 / var(--width_base)))) calc(100vw * (calc(36 / var(--width_base))));
    }
    
    & .sub-menu > .sub-menu__item .menu__link{
      color: white;
    }
  `;


  const listCss= css`
    position: relative;
    z-index: 1;
    background-color: white;
  `;

  return (
    <AnimateHeight
      id='list-movil'
      duration={ 300 }
      height={heightList} className="only-mov" css={listCss}>
        <ListMovil menuItems={menuItems} wordPressUrl={wordPressUrl} styleCss={menuListCss} classEle={"active"}/>
    </AnimateHeight>
  );
}

export default MenuMovil

